document.addEventListener('DOMContentLoaded', function () {
    if (!window.shouldShowFeatureSurveyBanner) return;

    setTimeout(() => {
        import('./banners/feature_survey_banner.js')
            .then(mod => mod.renderBanner())
            .catch(err => console.error("Survey banner error:", err));
    }, 700);
});
